var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirefox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5388 3.65035C12.8982 2.79322 12.0749 2.09229 11.1297 1.59938C10.1845 1.10647 9.14157 0.834172 8.07801 0.802627C6.40719 0.768871 5.25301 1.2754 4.60001 1.68266C5.47374 1.17141 6.73819 0.881393 7.84524 0.89573C10.6929 0.932028 13.7514 2.88865 14.2056 6.41532C14.7273 10.4636 11.9324 13.8423 8.00066 13.8527C3.67519 13.8638 1.04429 9.99988 1.73201 6.52929C1.7448 6.35912 1.76963 6.19008 1.80631 6.02348C1.89117 5.134 2.14739 4.26979 2.56059 3.47939C2.06247 3.73946 1.42818 4.56196 1.11517 5.32385C0.659526 6.48628 0.49888 7.74512 0.647814 8.98609C0.658608 9.0801 0.668322 9.17393 0.680554 9.26721C0.867084 10.3508 1.29485 11.3776 1.93164 12.2703C2.56843 13.1629 3.39765 13.8982 4.35688 14.4208C5.31611 14.9433 6.38034 15.2396 7.46946 15.2871C8.55858 15.3347 9.6442 15.1323 10.6446 14.6953C11.645 14.2583 12.5341 13.598 13.2449 12.7642C13.9558 11.9304 14.4698 10.9447 14.7485 9.88142C15.0271 8.81814 15.063 7.70493 14.8534 6.62562C14.6439 5.54632 14.1944 4.52903 13.5388 3.65035V3.65035Z",
    fill: "url(#paint0_radial)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M13.5388 3.65035C12.8982 2.79322 12.0749 2.09229 11.1297 1.59938C10.1845 1.10647 9.14157 0.834172 8.07801 0.802627C6.40719 0.768871 5.25301 1.2754 4.60001 1.68266C5.47374 1.17141 6.73819 0.881393 7.84524 0.89573C10.6929 0.932028 13.7514 2.88865 14.2056 6.41532C14.7273 10.4636 11.9324 13.8423 8.00066 13.8527C3.67519 13.8638 1.04429 9.99988 1.73201 6.52929C1.7448 6.35912 1.76963 6.19008 1.80631 6.02348C1.89117 5.134 2.14739 4.26979 2.56059 3.47939C2.06247 3.73946 1.42818 4.56196 1.11517 5.32385C0.659526 6.48628 0.49888 7.74512 0.647814 8.98609C0.658608 9.0801 0.668322 9.17393 0.680554 9.26721C0.867084 10.3508 1.29485 11.3776 1.93164 12.2703C2.56843 13.1629 3.39765 13.8982 4.35688 14.4208C5.31611 14.9433 6.38034 15.2396 7.46946 15.2871C8.55858 15.3347 9.6442 15.1323 10.6446 14.6953C11.645 14.2583 12.5341 13.598 13.2449 12.7642C13.9558 11.9304 14.4698 10.9447 14.7485 9.88142C15.0271 8.81814 15.063 7.70493 14.8534 6.62562C14.6439 5.54632 14.1944 4.52903 13.5388 3.65035V3.65035Z",
    fill: "url(#paint1_radial)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5388 3.65035C12.8982 2.79322 12.0749 2.09229 11.1297 1.59938C10.1845 1.10647 9.14157 0.834172 8.07801 0.802627C6.40719 0.768871 5.25301 1.2754 4.60001 1.68266C5.47374 1.17141 6.73819 0.881393 7.84524 0.89573C10.6929 0.932028 13.7514 2.88865 14.2056 6.41532C14.7273 10.4636 11.9324 13.8423 8.00066 13.8527C3.67519 13.8638 1.04429 9.99988 1.73201 6.52929C1.7448 6.35912 1.76963 6.19008 1.80631 6.02348C1.89117 5.134 2.14739 4.26979 2.56059 3.47939C2.06247 3.73946 1.42818 4.56196 1.11517 5.32385C0.659526 6.48628 0.49888 7.74512 0.647814 8.98609C0.658608 9.0801 0.668322 9.17393 0.680554 9.26721C0.867084 10.3508 1.29485 11.3776 1.93164 12.2703C2.56843 13.1629 3.39765 13.8982 4.35688 14.4208C5.31611 14.9433 6.38034 15.2396 7.46946 15.2871C8.55858 15.3347 9.6442 15.1323 10.6446 14.6953C11.645 14.2583 12.5341 13.598 13.2449 12.7642C13.9558 11.9304 14.4698 10.9447 14.7485 9.88142C15.0271 8.81814 15.063 7.70493 14.8534 6.62562C14.6439 5.54632 14.1944 4.52903 13.5388 3.65035V3.65035Z",
    fill: "url(#paint2_radial)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5388 3.65035C12.8982 2.79322 12.0749 2.09229 11.1297 1.59938C10.1845 1.10647 9.14157 0.834172 8.07801 0.802627C6.40719 0.768871 5.25301 1.2754 4.60001 1.68266C5.47374 1.17141 6.73819 0.881393 7.84524 0.89573C10.6929 0.932028 13.7514 2.88865 14.2056 6.41532C14.7273 10.4636 11.9324 13.8423 8.00066 13.8527C3.67519 13.8638 1.04429 9.99988 1.73201 6.52929C1.7448 6.35912 1.76963 6.19008 1.80631 6.02348C1.89117 5.134 2.14739 4.26979 2.56059 3.47939C2.06247 3.73946 1.42818 4.56196 1.11517 5.32385C0.659526 6.48628 0.49888 7.74512 0.647814 8.98609C0.658608 9.0801 0.668322 9.17393 0.680554 9.26721C0.867084 10.3508 1.29485 11.3776 1.93164 12.2703C2.56843 13.1629 3.39765 13.8982 4.35688 14.4208C5.31611 14.9433 6.38034 15.2396 7.46946 15.2871C8.55858 15.3347 9.6442 15.1323 10.6446 14.6953C11.645 14.2583 12.5341 13.598 13.2449 12.7642C13.9558 11.9304 14.4698 10.9447 14.7485 9.88142C15.0271 8.81814 15.063 7.70493 14.8534 6.62562C14.6439 5.54632 14.1944 4.52903 13.5388 3.65035V3.65035Z",
    fill: "url(#paint3_radial)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5388 3.65035C12.8982 2.79322 12.0749 2.09229 11.1297 1.59938C10.1845 1.10647 9.14157 0.834172 8.07801 0.802627C6.40719 0.768871 5.25301 1.2754 4.60001 1.68266C5.47374 1.17141 6.73819 0.881393 7.84524 0.89573C10.6929 0.932028 13.7514 2.88865 14.2056 6.41532C14.7273 10.4636 11.9324 13.8423 8.00066 13.8527C3.67519 13.8638 1.04429 9.99988 1.73201 6.52929C1.7448 6.35912 1.76963 6.19008 1.80631 6.02348C1.89117 5.134 2.14739 4.26979 2.56059 3.47939C2.06247 3.73946 1.42818 4.56196 1.11517 5.32385C0.659526 6.48628 0.49888 7.74512 0.647814 8.98609C0.658608 9.0801 0.668322 9.17393 0.680554 9.26721C0.867084 10.3508 1.29485 11.3776 1.93164 12.2703C2.56843 13.1629 3.39765 13.8982 4.35688 14.4208C5.31611 14.9433 6.38034 15.2396 7.46946 15.2871C8.55858 15.3347 9.6442 15.1323 10.6446 14.6953C11.645 14.2583 12.5341 13.598 13.2449 12.7642C13.9558 11.9304 14.4698 10.9447 14.7485 9.88142C15.0271 8.81814 15.063 7.70493 14.8534 6.62562C14.6439 5.54632 14.1944 4.52903 13.5388 3.65035V3.65035Z",
    fill: "url(#paint4_radial)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2057 6.41531C14.2622 6.85126 14.2802 7.29139 14.2597 7.73056C14.4983 7.69426 14.7374 7.6622 14.9769 7.63437C14.9011 6.1916 14.4004 4.80445 13.5389 3.65035C12.8983 2.79322 12.075 2.09229 11.1298 1.59938C10.1846 1.10647 9.14165 0.834172 8.0781 0.802627C6.40728 0.768871 5.2531 1.2754 4.6001 1.68266C5.47383 1.17141 6.73828 0.881393 7.84532 0.89573C10.693 0.932391 13.7515 2.8881 14.2057 6.41531Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3807 6.21408C13.9758 2.52843 10.7178 0.871807 7.84512 0.895764C6.7379 0.904838 5.47363 1.17144 4.59991 1.68269C4.36871 1.821 4.15386 1.9854 3.9595 2.17271C3.98271 2.15329 4.05197 2.09576 4.16673 2.01627L4.17807 2.00846L4.18814 2.00157C4.61213 1.71236 5.07928 1.4935 5.57185 1.35329C6.3435 1.13811 7.1433 1.04367 7.94334 1.07326C9.42818 1.16272 10.8267 1.80708 11.8661 2.88062C12.9055 3.95417 13.5111 5.37988 13.5649 6.87959C13.6309 9.2765 11.6865 11.1876 9.44506 11.2983C7.8149 11.3789 6.279 10.583 5.52886 8.99102C5.35338 8.62844 5.23421 8.24079 5.17556 7.84166C4.82009 5.4188 6.43281 3.35256 7.91168 2.84095C7.11387 2.13787 5.11475 2.1856 3.62689 3.28995C2.55546 4.08523 1.86037 5.29521 1.63011 6.73822C1.46445 7.84542 1.6103 8.97732 2.05105 10.005C2.50886 11.0948 3.25699 12.0354 4.21243 12.7223C5.16787 13.4093 6.29326 13.8157 7.46376 13.8966C7.64233 13.9104 7.82126 13.9173 8.00055 13.9171C12.7608 13.9171 14.8259 10.2716 14.3807 6.21408V6.21408Z",
    fill: "url(#paint6_radial)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3807 6.21408C13.9758 2.52843 10.7178 0.871807 7.84512 0.895764C6.7379 0.904838 5.47363 1.17144 4.59991 1.68269C4.36871 1.821 4.15386 1.9854 3.9595 2.17271C3.98271 2.15329 4.05197 2.09576 4.16673 2.01627L4.17807 2.00846L4.18814 2.00157C4.61213 1.71236 5.07928 1.4935 5.57185 1.35329C6.3435 1.13811 7.1433 1.04367 7.94334 1.07326C9.42818 1.16272 10.8267 1.80708 11.8661 2.88062C12.9055 3.95417 13.5111 5.37988 13.5649 6.87959C13.6309 9.2765 11.6865 11.1876 9.44506 11.2983C7.8149 11.3789 6.279 10.583 5.52886 8.99102C5.35338 8.62844 5.23421 8.24079 5.17556 7.84166C4.82009 5.4188 6.43281 3.35256 7.91168 2.84095C7.11387 2.13787 5.11475 2.1856 3.62689 3.28995C2.55546 4.08523 1.86037 5.29521 1.63011 6.73822C1.46445 7.84542 1.6103 8.97732 2.05105 10.005C2.50886 11.0948 3.25699 12.0354 4.21243 12.7223C5.16787 13.4093 6.29326 13.8157 7.46376 13.8966C7.64233 13.9104 7.82126 13.9173 8.00055 13.9171C12.7608 13.9171 14.8259 10.2716 14.3807 6.21408V6.21408Z",
    fill: "url(#paint7_radial)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M14.3807 6.21408C13.9758 2.52843 10.7178 0.871807 7.84512 0.895764C6.7379 0.904838 5.47363 1.17144 4.59991 1.68269C4.36871 1.821 4.15386 1.9854 3.9595 2.17271C3.98271 2.15329 4.05197 2.09576 4.16673 2.01627L4.17807 2.00846L4.18814 2.00157C4.61213 1.71236 5.07928 1.4935 5.57185 1.35329C6.3435 1.13811 7.1433 1.04367 7.94334 1.07326C9.42818 1.16272 10.8267 1.80708 11.8661 2.88062C12.9055 3.95417 13.5111 5.37988 13.5649 6.87959C13.6309 9.2765 11.6865 11.1876 9.44506 11.2983C7.8149 11.3789 6.279 10.583 5.52886 8.99102C5.35338 8.62844 5.23421 8.24079 5.17556 7.84166C4.82009 5.4188 6.43281 3.35256 7.91168 2.84095C7.11387 2.13787 5.11475 2.1856 3.62689 3.28995C2.55546 4.08523 1.86037 5.29521 1.63011 6.73822C1.46445 7.84542 1.6103 8.97732 2.05105 10.005C2.50886 11.0948 3.25699 12.0354 4.21243 12.7223C5.16787 13.4093 6.29326 13.8157 7.46376 13.8966C7.64233 13.9104 7.82126 13.9173 8.00055 13.9171C12.7608 13.9171 14.8259 10.2716 14.3807 6.21408V6.21408Z",
    fill: "url(#paint8_radial)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M14.3807 6.21408C13.9758 2.52843 10.7178 0.871807 7.84512 0.895764C6.7379 0.904838 5.47363 1.17144 4.59991 1.68269C4.36871 1.821 4.15386 1.9854 3.9595 2.17271C3.98271 2.15329 4.05197 2.09576 4.16673 2.01627L4.17807 2.00846L4.18814 2.00157C4.61213 1.71236 5.07928 1.4935 5.57185 1.35329C6.3435 1.13811 7.1433 1.04367 7.94334 1.07326C9.42818 1.16272 10.8267 1.80708 11.8661 2.88062C12.9055 3.95417 13.5111 5.37988 13.5649 6.87959C13.6309 9.2765 11.6865 11.1876 9.44506 11.2983C7.8149 11.3789 6.279 10.583 5.52886 8.99102C5.35338 8.62844 5.23421 8.24079 5.17556 7.84166C4.82009 5.4188 6.43281 3.35256 7.91168 2.84095C7.11387 2.13787 5.11475 2.1856 3.62689 3.28995C2.55546 4.08523 1.86037 5.29521 1.63011 6.73822C1.46445 7.84542 1.6103 8.97732 2.05105 10.005C2.50886 11.0948 3.25699 12.0354 4.21243 12.7223C5.16787 13.4093 6.29326 13.8157 7.46376 13.8966C7.64233 13.9104 7.82126 13.9173 8.00055 13.9171C12.7608 13.9171 14.8259 10.2716 14.3807 6.21408V6.21408Z",
    fill: "url(#paint9_radial)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44524 11.2983C12.5214 11.1095 13.8382 8.53967 13.9208 6.71661C14.0496 3.86815 12.3746 0.797358 7.94351 1.07322C7.14343 1.04381 6.34362 1.13843 5.572 1.3538C5.08162 1.49996 4.61535 1.71841 4.18827 2.00208L4.1782 2.00898L4.16686 2.01678C4.09802 2.06518 4.03068 2.11612 3.96484 2.16959C5.11179 1.52256 6.43701 1.27169 7.73843 1.45525C10.2825 1.7921 12.6085 3.78866 12.6085 6.42315C12.6085 8.45019 11.0558 9.99847 9.23765 9.88722C6.53658 9.72388 5.85568 6.92896 7.26082 5.72133C6.88197 5.63912 6.16996 5.80028 5.67417 6.54801C5.2293 7.21952 5.25449 8.25582 5.529 8.99103C5.87117 9.73224 6.42954 10.3504 7.1294 10.7627C7.82926 11.175 8.63724 11.3619 9.44524 11.2983V11.2983Z",
    fill: "url(#paint10_radial)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5388 3.65038C13.3461 3.39579 13.1369 3.15437 12.9125 2.92769C12.7343 2.73764 12.5433 2.5602 12.341 2.39666C12.4574 2.49897 12.5684 2.60741 12.6736 2.72152C13.0673 3.14545 13.3668 3.64938 13.5518 4.19956C13.9276 5.3482 13.9031 6.78576 13.1855 7.91479C12.7871 8.54746 12.2307 9.06322 11.5722 9.41029C10.9137 9.75737 10.1762 9.92353 9.43392 9.8921C9.36898 9.8921 9.3035 9.8921 9.23766 9.8872C6.5366 9.72386 5.85572 6.92895 7.26102 5.72133C6.88199 5.63912 6.16999 5.80028 5.67421 6.54801C5.22934 7.21952 5.25452 8.25581 5.52904 8.99102C5.35361 8.62843 5.23451 8.24078 5.17591 7.84165C4.82027 5.41879 6.43299 3.35256 7.91187 2.84094C7.11405 2.13786 5.11493 2.18559 3.62705 3.28994C2.75195 3.9499 2.11473 4.88041 1.8125 5.93966C1.90882 5.08011 2.16251 4.24607 2.56066 3.47996C2.06255 3.74003 1.42825 4.56254 1.11524 5.32442C0.659688 6.48669 0.499043 7.74533 0.647886 8.98612C0.65868 9.08013 0.668394 9.17396 0.680626 9.26724C0.867156 10.3508 1.29492 11.3776 1.93171 12.2703C2.5685 13.163 3.39772 13.8983 4.35695 14.4208C5.31618 14.9434 6.38041 15.2396 7.46953 15.2871C8.55865 15.3347 9.64427 15.1323 10.6447 14.6953C11.645 14.2583 12.5341 13.5981 13.245 12.7642C13.9558 11.9304 14.4699 10.9447 14.7485 9.88145C15.0272 8.81816 15.0631 7.70496 14.8535 6.62565C14.644 5.54634 14.1945 4.52906 13.5388 3.65038V3.65038Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5518 4.19956C13.3668 3.64936 13.0674 3.14542 12.6735 2.72152C12.2056 2.22956 11.6508 1.82993 11.0376 1.54313C10.5257 1.28855 9.98593 1.09552 9.42938 0.967991C8.44831 0.751337 7.43306 0.745154 6.44948 0.949842C5.42715 1.16763 4.52823 1.61391 3.95959 2.1718C4.413 1.91338 4.89898 1.71802 5.4043 1.59104C6.38624 1.3421 7.41446 1.34626 8.39438 1.60314C9.3743 1.86002 10.2745 2.36138 11.0121 3.06109C11.311 3.34711 11.5727 3.67033 11.7908 4.02297C12.6714 5.46743 12.5881 7.2834 11.9015 8.35436C11.3915 9.15 10.2992 9.897 9.28007 9.88829C10.0471 9.9467 10.8154 9.79404 11.5032 9.44659C12.191 9.09914 12.7724 8.56992 13.1855 7.91534C13.9031 6.78576 13.9276 5.3482 13.5518 4.19956V4.19956Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5518 4.19956C13.3668 3.64936 13.0674 3.14542 12.6735 2.72152C12.2056 2.22956 11.6508 1.82993 11.0376 1.54313C10.5257 1.28855 9.98593 1.09552 9.42938 0.967991C8.44831 0.751337 7.43306 0.745154 6.44948 0.949842C5.42715 1.16763 4.52823 1.61391 3.95959 2.1718C4.413 1.91338 4.89898 1.71802 5.4043 1.59104C6.38624 1.3421 7.41446 1.34626 8.39438 1.60314C9.3743 1.86002 10.2745 2.36138 11.0121 3.06109C11.311 3.34711 11.5727 3.67033 11.7908 4.02297C12.6714 5.46743 12.5881 7.2834 11.9015 8.35436C11.3915 9.15 10.2992 9.897 9.28007 9.88829C10.0471 9.9467 10.8154 9.79404 11.5032 9.44659C12.191 9.09914 12.7724 8.56992 13.1855 7.91534C13.9031 6.78576 13.9276 5.3482 13.5518 4.19956V4.19956Z",
    fill: "url(#paint13_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4645 3.77467) scale(16.3305 16.4755)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FC4055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.78922 4.45616) scale(9.6648 9.75061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#C60084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4055",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.8604 2.8371) scale(19.1762 19.3464)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE67",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#FFD966",
    stopOpacity: 0.581
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#FFCA65",
    stopOpacity: 0.525
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#FEB262",
    stopOpacity: 0.432
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#FE8F5E",
    stopOpacity: 0.302
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#FD6459",
    stopOpacity: 0.137
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#FC4055",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.2034 8.85977) scale(24.7387 24.9584)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#810220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#920B27",
    stopOpacity: 0.861
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#CB2740",
    stopOpacity: 0.398
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#EF394F",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#FC4055",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.33128 8.54598) scale(24.7387 24.9584)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#810220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#920B27",
    stopOpacity: 0.861
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#CB2740",
    stopOpacity: 0.398
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257,
    stopColor: "#EF394F",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#FC4055",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 8.84138,
    y1: 2.21424,
    x2: 13.1357,
    y2: 9.58679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#FF9640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.0911 2.99547) scale(15.3301 15.4986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FC4055"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.0911 2.99547) scale(15.3301 15.4986)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#FFDE67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.147,
    stopColor: "#FFDC66",
    stopOpacity: 0.968
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#FFD562",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#FFCB5D",
    stopOpacity: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#FFBC55",
    stopOpacity: 0.533
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#FFAA4B",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#FF9640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.57984 7.81609) rotate(75.8486) scale(7.59491 7.8499)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#FC4055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#FD604D",
    stopOpacity: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#FE8644",
    stopOpacity: 0.181
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FF9640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.28459 8.44129) scale(7.5176 7.58437)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#FC4055",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#FD5251",
    stopOpacity: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FE8345",
    stopOpacity: 0.181
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#FF9640",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1509 1.24471) scale(25.9111 26.1956)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#FFF36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#FF9640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#FF9640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 11.2197,
    y1: 2.0865,
    x2: 3.76474,
    y2: 14.8855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF36E",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FFF36E",
    stopOpacity: 0.699
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#FFF36E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 7.8976,
    y1: 0.679425,
    x2: 11.866,
    y2: 12.0685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B833E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    stopColor: "#5B6DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 5.5815,
    y1: 0.859824,
    x2: 12.9062,
    y2: 8.12015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#722291",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#592ACB",
    stopOpacity: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.cfd36ba3f1594c4192faf948a5f1dcb3.svg";
export { ForwardRef as ReactComponent };